import {SharedQuestion} from "./SharedQuestion";

export class UploadSharedQuestion extends SharedQuestion {

    protected values:IValue[] = [];

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        return this.validateValues();
    }

    validateValues():boolean {
        const values = this.getValue();

        for (let value of values) {
            if (!angular.isString(value.value.hash)) {
                return false;
            }
        }

        return values && values.length > 0;
    }

    validationMessage() : string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'upload_validation_message';
    }

    getValue():IValue[] {
        return this.values;
    }

    setValue(values:IValue[]) {
        this.values = values;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        for (let currentValue of currentValues) {
            if (currentValue.value.hash === value.value.hash) {
                return true;
            }
        }

        return false;
    }
}